import { render, staticRenderFns } from "./salarySettingEdit.vue?vue&type=template&id=2e77861a&scoped=true"
import script from "./salarySettingEdit.vue?vue&type=script&lang=js"
export * from "./salarySettingEdit.vue?vue&type=script&lang=js"
import style0 from "./salarySettingEdit.vue?vue&type=style&index=0&id=2e77861a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e77861a",
  null
  
)

export default component.exports